import React from 'react';
import {
  NumericInput,
  Button,
  Typography,
  TypographyType,
  TypographyVariant,
} from 'src/components-dummy';
import './SimilarByPatternSettings.scss';
import { SimilarByPatternSettingsProps } from './types';
import { useSimilarByPatternSettingsDraft } from './useSimilarByPatternSettingsDraft';
import { createOptionalPortal } from '../helpers';
import { ConfigurationNote } from '../../components-dummy/Labels/ConfigurationNote';
import { ConfigurationVariant } from '../../components-dummy/Labels/configuration-variant';

const NUMERIC_INPUT_DECIMAL_PLACES = 3;

export const SimilarByPatternSettings = ({
  shopId,
  similarByPatternSettings,
  formHeaderElementRef,
  onIsDirty,
  dispatch,
  disabled = false,
  shouldRefetch,
}: SimilarByPatternSettingsProps): JSX.Element | null => {
  const similarByPattern = useSimilarByPatternSettingsDraft({
    similarByPatternSettings,
    dispatch,
    shopId,
    onIsDirty,
    shouldRefetch,
  });

  const { draftSimilarByPatternSettings, isValid, isDirty, onSubmit, onDiscard, onChange, errors } =
    similarByPattern;

  const formButtons = !disabled && (
    <>
      <Button onClick={onDiscard} variant='tertiary' disabled={!isDirty}>
        Discard
      </Button>
      <Button onClick={onSubmit} disabled={!(isValid && isDirty)} variant='primary'>
        Save
      </Button>
    </>
  );

  const formButtonsSection = createOptionalPortal({
    portalContent: disabled ? <></> : formButtons,
    targetContainerRef: formHeaderElementRef,
    fallback: <div className='ranking-button-wrapper'>{formButtons}</div>,
  });

  return (
    <>
      <div className='similar-by-pattern-settings-container-wrapper'>
        <div className='similar-by-pattern-settings-container'>
          <Typography
            type={TypographyType.Body}
            variant={TypographyVariant.MediumRegular}
            className='results-display-title'
          >
            Results Display
          </Typography>
          <div className='similar-by-pattern-results-to-display'>
            <span className='results-to-display-title'>
              <Typography type={TypographyType.Body} variant={TypographyVariant.MediumRegular}>
                Number of results to display (3-20)
              </Typography>
            </span>
            <div className='results-to-display-input-wrapper'>
              <NumericInput
                disabled={disabled}
                error={!!errors.numberOfResultsToDisplay}
                value={draftSimilarByPatternSettings.numberOfResultsToDisplay}
                onChange={value => {
                  onChange({ numberOfResultsToDisplay: value });
                }}
                className='results-to-display-input'
                decimals={NUMERIC_INPUT_DECIMAL_PLACES}
              />
              {!!errors.numberOfResultsToDisplay && (
                <span className='results-to-display-input-error'>
                  <Typography type={TypographyType.Body} variant={TypographyVariant.MediumRegular}>
                    Please enter a number between 3 to 20
                  </Typography>
                </span>
              )}
            </div>
          </div>
          {formButtonsSection}
        </div>
      </div>
      <ConfigurationNote variant={ConfigurationVariant.allAboveToNonApiUsers} />
    </>
  );
};
